export default __webpack_public_path__ + "files/80c22aa38ecd238ca10523a5fd53980a.png";